import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Description from './Description';
import Specifications from './Specifications';
import IconSetting from '../../shared/icons/icon-setting.svg';
import IconInfo from '../../shared/icons/icon-info2.svg';


class ProductInfoWrapper extends Component {
  static getDomId() {
    return 'product_description';
  }

  constructor(props) {
    super(props);
    this.state = {
      activeTab: '',
    }

    this.handleClick = this.handleClick.bind(this);
    this.updateActiveTab = this.updateActiveTab.bind(this);
  }

  static getComponentData() {
    const componentData = window.seMarketplace.product;

    
    if (!componentData) {
      return null;
    }

    const { shortDescription, longDescription,  specifications, warranty} = componentData;

    return {
      shortDescription,
      longDescription,
      specifications,
      warranty,
    };
  }

  componentDidMount() {
    this.updateActiveTab();
  }

  handleClick(event) {
    this.setState({ activeTab: event.target.id });
  }

  updateActiveTab() {
    const activeSection = (this.props.shortDescription || this.props.longDescription) ? 'product-info' :  
                          (this.props.specifications || this.props.warranty) ? 'specifications' : '';
    this.setState({ activeTab: activeSection });
  }

  render() {
    const { shortDescription, longDescription, specifications, warranty } = this.props;
    const showNavItem = ((shortDescription || longDescription) && (specifications || warranty));
    const { activeTab } = this.state;
    
    return (
      <>
      {showNavItem && (
        <div className='product-info__navigation se-container'>
          <div 
            id='product-info'
            className={`product-info__navitem ${activeTab === 'product-info' ? 'active' : ''}`} 
            onClick={this.handleClick}
            >
            <IconInfo className='product-info__navitem--icon' />
            Product Info
          </div>
          <div
            id='specifications'
            className={`product-info__navitem ${activeTab === 'specifications' ? 'active' : ''}`}
            onClick={this.handleClick}
            >
            <IconSetting className='product-info__navitem--icon' />
            Specifications
          </div>
        </div>
      )}
      { activeTab && (
        <div className="se-tier se-tier--bg-light-grey">
          <div className="se-container">
            <div className="se-row">
              {activeTab === 'product-info' && 
                <Description shortDescription={shortDescription} longDescription={longDescription} />
              }
              {activeTab === 'specifications' &&
                <Specifications specifications={specifications} warranty={warranty} />
              }
              </div>
            </div>
          </div>
      )}
    </>
    );
  }
}

ProductInfoWrapper.propTypes = {
  shortDescription: PropTypes.string.isRequired,
  longDescription: PropTypes.string.isRequired,
  specifications: PropTypes.string,
  warranty: PropTypes.string,
};

export default ProductInfoWrapper;
